export default __webpack_public_path__ + "static/media/j.c69bb53d.svg";